import { render, staticRenderFns } from "./SelectTab.vue?vue&type=template&id=fd85e5bc&scoped=true&"
import script from "./SelectTab.vue?vue&type=script&lang=js&"
export * from "./SelectTab.vue?vue&type=script&lang=js&"
import style0 from "./SelectTab.vue?vue&type=style&index=0&id=fd85e5bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd85e5bc",
  null
  
)

export default component.exports